import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const stats = [{
  value: '+560',
  label: 'Páginas'
}, {
  value: '+80',
  label: 'Protocolos'
}, {
  value: '6',
  label: 'Tomos'
}, {
  value: '6',
  label: 'Bonos'
}];
const situations = ['Riesgo suicida en adolescentes', 'Agitación en niños y adolescentes', 'Internación de menores', 'Farmacoterapia pediátrica', 'Ley 26.061', 'Consentimiento en menores', 'Abuso infantil y denuncia', 'Crisis psicótica en adolescentes', 'Comunicación con padres', 'Habeas corpus en menores', 'Informe para juzgado de familia', 'Coordinación con escuela', 'Conflicto entre progenitores', 'Burnout en especialidad', 'Sumario en psiquiatría infantil', 'Alta y seguimiento ambulatorio', 'OVD y organismos de protección', 'Responsabilidad médica en menores'];
export function StatsAndSituations() {
  return <SectionWrapper data-id="element-222">
      <div className="text-center mb-8 md:mb-12" data-id="element-223">
        <h2 className="text-[20px] md:text-3xl font-extrabold text-[#0a1f44] mb-2 md:mb-4 text-balance tracking-tight" data-id="element-224">
          El sistema más completo para la psiquiatría infantojuvenil en
          Argentina
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-225">
        {stats.map((stat, i) => <div key={i} className="bg-white ring-1 ring-slate-900/5 rounded-2xl p-4 md:p-6 text-center shadow-sm" data-id="element-226">
            <div className="text-2xl md:text-4xl font-black text-orange-600 mb-1 drop-shadow-sm" data-id="element-227">
              {stat.value}
            </div>
            <div className="text-[11px] md:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-228">
              {stat.label}
            </div>
          </div>)}
      </div>

      <div className="bg-slate-50 rounded-3xl p-5 md:p-10 ring-1 ring-slate-900/5 shadow-inner" data-id="element-229">
        <div className="text-center mb-6 md:mb-8" data-id="element-230">
          <h3 className="text-[18px] md:text-2xl font-bold text-[#0a1f44] mb-1 md:mb-2" data-id="element-231">
            Funciona desde tu primera consulta
          </h3>
          <p className="text-slate-600 text-[14px] md:text-base" data-id="element-232">
            Situaciones cubiertas:
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-233">
          {situations.map((sit, i) => <span key={i} className="bg-white ring-1 ring-slate-200 text-slate-700 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-[12px] md:text-sm font-medium shadow-sm hover:ring-blue-300 transition-colors cursor-default" data-id="element-234">
              {sit}
            </span>)}
        </div>
      </div>
    </SectionWrapper>;
}